module.exports = __webpack_public_path__ + "img/jigyoshokei_foot.6f61fcd6.png";